import { Injectable } from '@angular/core';
import { HemroDrawerComponent } from '@hemro/components/drawer/drawer.component';


@Injectable({
    providedIn: 'root'
})
export class HemroDrawerService
{
    private _componentRegistry: Map<string, HemroDrawerComponent> = new Map<string, HemroDrawerComponent>();

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register drawer component
     *
     * @param name
     * @param component
     */
    registerComponent(name: string, component: HemroDrawerComponent): void
    {
        this._componentRegistry.set(name, component);
    }

    /**
     * Deregister drawer component
     *
     * @param name
     */
    deregisterComponent(name: string): void
    {
        this._componentRegistry.delete(name);
    }

    /**
     * Get drawer component from the registry
     *
     * @param name
     */
    getComponent(name: string): HemroDrawerComponent | undefined
    {
        return this._componentRegistry.get(name);
    }
}
